import request from '@/utils/request'

/**
 * 查询店铺审核列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopAudit(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAudit.queryShopAudit',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询店铺信息
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShop(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShop',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}